import { createRequest, RequestConfig } from 'app/common/api';

// import { createMockHandler } from 'app/common/api/create-mock-handler';
// import { TPersonData } from '../core/person';
import { TPersonConstraints } from '../core/person-constraints';

const config: RequestConfig = {
  method: 'post',
  url: '/ws/api/get_persons',
};

export const getPersonsRequest = (constraints?: TPersonConstraints) =>
  createRequest({
    url: config.url,
    method: config.method,
    body: JSON.stringify(constraints),
  });
